import { ApplicantStatus, ApplicationStatus } from "shared/types";

interface ApplicantLike {
  application_status: ApplicantStatus;
}

export type ApplicationLike =
  | {
      status: ApplicationStatus;
      applicants: ApplicantLike[];
    }
  | undefined;

export const getApplicationUIStatus = (
  application: ApplicationLike
): ApplicationStatus | undefined => {
  if (!application) return;

  const { status, applicants } = application;
  if (applicants.length === 0) return status;

  const hasSubmittedApplicant = applicants.some(
    (applicant) => applicant.application_status === ApplicantStatus.Submitted
  );

  const shouldDisplayAsPartiallySubmitted =
    hasSubmittedApplicant &&
    [ApplicationStatus.Started, ApplicationStatus.Pending].includes(status);

  if (status === ApplicationStatus.PartiallySubmitted) return status;

  if (shouldDisplayAsPartiallySubmitted)
    return ApplicationStatus.PartiallySubmitted;

  return status;
};
